import React, { useState, FC, KeyboardEvent } from 'react'
import Icon from '../../Core/Iconography/Icon/Icon'
import Label from '../Label/Label'
import {
  InputMainWrapper,
  InputWrapper,
  InputStyle,
  IconWrapper,
  ErrorLabel,
} from './Input.styles'
import { InputProps } from './types'

const Input: FC<InputProps> = props => {
  const { labelSpacer, isDatePicker, label, error, clickAction, errorLabelEllipsis, placeholderAsValue } = props

  const [isOnFocus, setFocus] = useState(false)

  const click: () => void = () => clickAction && clickAction()

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    //  On press enter key + on focus (Accessibility)
    if (event?.keyCode === 13 && isOnFocus) click()
  }
  return (
    <InputMainWrapper
      gridArea={props.gridArea}
      gridColumn={props.gridColumn}
      addSeparatorLine={props.addSeparatorLine}
      fixWidth={props.fixWidth}
      minHeight={props.minHeight}
      paddingLeft={props.paddingLeft}
      flexProperties={props.flexProperties}
      marginBottom={props.marginBottom}
    >
      <Label
        label={label}
        name={props.name}
        required={props.required}
        tooltipLabel={props.tooltipLabel}
        removeEllipsis={props.removeLabelEllipsis}
        flexWrapperCentered={props.flexWrapperCentered}
      />
      <InputWrapper labelSpacer={labelSpacer} width={props.width}>
        <InputStyle
          data-testid='input'
          as={props.isTextarea ? 'textarea' : 'input'}
          {...props}
          placeholderAsValue={placeholderAsValue}
          maxLength={parseInt(props.maxlength)}
          id={props.name}
          label={undefined}
          pattern={undefined}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          onKeyDown={handleKeyDown}
          onClick={click}
        />
        {isDatePicker && (
          <IconWrapper labelSpacer={labelSpacer} onClick={click}>
            <Icon name='calendar' color='ultraViolet' size='s' />
          </IconWrapper>
        )}
      </InputWrapper>
      {error && <ErrorLabel errorLabelEllipsis={errorLabelEllipsis}>{error}</ErrorLabel>}
    </InputMainWrapper>
  )
}

Input.defaultProps = {
  type: 'text',
  required: false,
  disabled: false,
  blocked: false,
  readOnly: false,
  error: '',
  isTextarea: false,
  isDatePicker: false,
  addSeparatorLine: false,
  removeLabelEllipsis: false,
  fixWidth: false,
  minHeight: '',
  labelSpacer: false,
}

export default Input
